import {Component, EventEmitter, Input, Output} from '@angular/core';
import {WidgetButton} from "../WidgetButton";
import {GridsterItem} from "angular-gridster2";

@Component({
  selector: 'app-widget-header',
  templateUrl: './WidgetHeader.component.html',
  styleUrls: ['./WidgetHeader.component.css']
})
export class WidgetHeaderComponent {

  @Input() gridsterItem!: GridsterItem;
  @Input() widgetTitle!: string;
  @Input() editMode!: boolean;
  @Input() hideEdit!: boolean;
  @Input() buttons!: WidgetButton[];

  @Output() editConfigurations = new EventEmitter();
  @Output() removeWidget = new EventEmitter();

  doNothing() {
  }

  isOverflown(element: HTMLElement) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
  }

  onSubMenuShown = (event: any) => {
    event.rootItem.style.pointerEvents = 'none';
  };

  onSubMenuHidden = (event: any) => {
    event.rootItem.style.pointerEvents = 'auto';
  };

}
